<template>
    <div class="producer">
        <div>
            <van-row type="flex" justify="space-between" class="search-row">
                <van-col :span="13">
                    <van-search placeholder="发票号码" v-model="originCertificateQuery.invoiceNum"/>
                </van-col>
                <van-col :span="11">
                    <van-field v-model="originCertificateQuery.statusLabel" :readonly="true" placeholder="全部状态"
                               @click="statusVisible = true"/>
                </van-col>
            </van-row>

            <van-row type="flex" class="search-row">
                <van-col :span="13">
                    <van-search placeholder="进口商名称" v-model="originCertificateQuery.importerName"/>
                </van-col>
                <van-col :span="11" style="display: flex;justify-content: flex-end;padding: 0;border: none">
                    <van-button type="info" @click="handleSearchOriginCertificateList">搜索</van-button>
                  <van-button type="info" style="margin-left: 8px" @click="OriginCertificateAdd">新建</van-button>
                </van-col>
            </van-row>

            <van-popup v-model="statusVisible" position="bottom">
                <common-picker @close="statusVisible = false" @confirm="statusConfirm"
                               :columns="statusOptions"></common-picker>
            </van-popup>

            <van-row class="rowHeader">
                <van-col :span="8">
                    <span>发票号码</span>
                </van-col>
                <van-col :span="10">
                    <span>收货人/进口商</span>
                </van-col>
                <van-col :span="6">
                    <span class="operate-position">状态/操作</span>
                </van-col>

            </van-row>

            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad">
                <van-row class="data-list" v-for="(item,index) in originCertificateList"
                         :class="{'last-data-list':originCertificateList.length - index === 1 }" :key="index">
                    <van-row>
                        <van-col :span="8">
                            {{ item.invoiceNumStr }}
                        </van-col>
                        <van-col :span="10">
                            {{ item.importer }}
                        </van-col>
                        <van-col :span="6">
                          <div class="operate-position">
                            <span>{{ item.status }}</span>
                            <div class="itemBtns">
                                <a type="info" v-if="item.status === '已保存'" class="" @click="showSendConfirmDialog(item)">发送</a>
                                <a type="info" v-if="item.status === '已保存'" class="" @click="showDeleteConfirmDialog(item)">删除</a>
                                <a type="info" class="" @click="OriginCertificateDetail(item)">详情</a>
                            </div>
                          </div>
                        </van-col>
                    </van-row>
                </van-row>
            </van-list>
        </div>

        <van-dialog
                v-model="showDeleteConfirm"
                title="你确定要删除当前项吗?"
                className="delete-confirm"
                show-confirm-button
                show-cancel-button
                @confirm="OriginCertificateDelete">
        </van-dialog>

        <van-dialog
                v-model="showSendConfirm"
                title="你确定要发送当前项吗?"
                className="delete-confirm"
                show-confirm-button
                show-cancel-button
                @confirm="OriginCertificateSend">
        </van-dialog>

    </div>
</template>

<script>
    import {noticeManager, PaginationManager} from "@zhoujianhui/vip-core";
    import OriginCertificateQuery from '../dto/OriginCertificateQuery'
    import CommonPicker from "../../component/CommonPicker";
    import certificateService from '../service/certificate-service'
    import originCertificateRegion from '../service/origin-certificate-region'

    export default {
        name: "ApplicationOrder",
        components: {
            CommonPicker
        },
        data() {
            return {
                statusVisible: false,
                originCertificateQuery: new OriginCertificateQuery(),
                paginationManager: new PaginationManager(null, null, ["lastModifiedDate,desc"]),
                originCertificateList: [],
                statusOptions: [
                    {value: 'SAVE', label: '已保存'},
                    {value: 'SEND', label: '已发送'},
                ],
                loading: false,
                finished: false,
                showDeleteConfirm: false,
                showSendConfirm: false,
                deleteId: '',
                sendId: ''
            }
        },
        methods: {
            //首次加载(搜索)
            handleSearchOriginCertificateList() {
                this.originCertificateList = [];
                this.paginationManager.currentPage = 1;
                this.searchOriginCertificateList();
                this.paginationManager.currentPage++;
            },
            onLoad() {
                this.searchOriginCertificateList();
                this.paginationManager.currentPage++;
            },
            statusConfirm(selectedStatus) {
                this.originCertificateQuery.status = selectedStatus.value;
                this.originCertificateQuery.statusLabel = selectedStatus.label;
                this.statusVisible = false;
            },
            async searchOriginCertificateList() {
                const result = await certificateService.searchOriginCertificateList(this.originCertificateQuery, this.paginationManager.toPageable());
                if (result.isSuccess()) {
                    let dataList = result.data.content;
                    dataList.length == 0 ? this.finished = true : this.finished = false;//判断是否需要结束下俩加载加载
                    this.originCertificateList = this.originCertificateList.concat(dataList);//合并数组
                    this.loading = false;
                } else {
                    noticeManager.showMessage(result.msg, result.type);
                }
            },
            OriginCertificateAdd() {
                this.$router.push('/origin-certificate/application-region');
            },
            showDeleteConfirmDialog(item) {
                this.deleteId = item.id;
                this.showDeleteConfirm = true;
            },
            showSendConfirmDialog(item) {
                this.sendId = item.id;
                this.showSendConfirm = true;
            },
            async OriginCertificateDelete() {
                const result = await certificateService.deleteOriginCertificate(this.deleteId);
                if (result.isSuccess()) {
                    this.originCertificateList = [];
                    this.paginationManager.currentPage = 1;
                    await this.searchOriginCertificateList();
                    this.paginationManager.currentPage++;
                }
                noticeManager.showMessage(result.msg, result.type);
            },
            async OriginCertificateSend() {
                let result = await certificateService.sendOriginCertificate(this.sendId);
                if (result.isSuccess()) {
                    this.originCertificateList = [];
                    this.paginationManager.currentPage = 1;
                    await this.searchOriginCertificateList();
                    this.paginationManager.currentPage++;
                }
                noticeManager.showMessage(result.msg, result.type);
            },
            OriginCertificateDetail(item) {
                const region = originCertificateRegion.valueOf(item.regionCode);
                let routePath = "#";
                switch (region.category) {
                  case "GENERAL":
                    routePath = '/general-origin-certificate/general-application-order-detail';
                    break;
                  case "PREF":
                    routePath = '/pref-origin-certificate/pref-application-order-detail';
                    break;
                  case "RCEP":
                    routePath = '/origin-certificate/application-order-detail';
                    break;
                }
                this.$router.push({
                    path: routePath,
                    query: {
                        viewedOriginCertificate: JSON.stringify(item)
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .producer {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .title {
            text-align: center;
            font-size: 0.17rem;
            font-weight: bold;
            padding: 0.2rem 0 0.15rem;
            color: #111111;
        }

        .van-button {
            height: 34px;
            line-height: 34px;
            border-radius: 5px;
        }

        .add-row {
            margin: .1rem 0;
            padding: 0 4%;
            box-sizing: border-box;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .add-row .van-button--primary {
            width: 92%;
            background-color: #1989fa;
            border: 1px solid #1989fa;
            height: 44px;
        }

        .data-list:first-child {
            margin-top: 10px;
        }

        .data-list {
            padding: .14rem .12rem;
            background: #ffffff;
            margin-bottom: 10px;

            .van-row {
                padding: 0 .12rem;
            }

            .van-row:first-child {
                color: #000000;
                font-size: 0.12rem;
                /*margin-bottom: .12rem;*/
            }

            .van-row:not(:first-child) {
                color: #999999;
            }

        }

        .last-data-list {
            border: none;
        }

        .search-row {
            align-items: center;
            padding-right: 12px;
            background: #ffffff;

            .van-col--5 {
                text-align: right;
            }

            .van-cell {
                padding: 5px 0;
                background: #ffffff;
            }

            .van-search__content {
                background: #ffffff;
                border: 1px solid #dcdfe6;
                border-radius: 5px;
            }

            .van-col--11 {
                border: 1px solid #dcdfe6;
                padding: 0 12px;
                border-radius: 5px;
            }
        }

        .itemBtns {
            display: flex;
            align-items: center;
            margin-top: 10px;
        }

        .itemBtns a:not(:last-child) {
            margin-right: 10px;
        }

        .rowHeader {
            font-size: .12rem;
            padding: 0.14rem 0.24rem;
        }
      .operate-position {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }
    }
</style>
